// extracted by mini-css-extract-plugin
export default {"wrapper":"types_wrapper__TeKSi","scroll":"types_scroll__k27Yz","head":"types_head__vO5mF","modal":"types_modal__BPCYA","btns":"types_btns__5mS9I","search":"types_search__iy-I-"};